import PrintersOutOfRibbonModal from './printers-out-of-ribbon-modal.connect'

export default PrintersOutOfRibbonModal
